import { getAdminAuthHeaders } from "./adminAuth";
import { API_ENDPOINTS } from "./endpoints";
import { requestJson } from "./httpClient";

export function backfillOrderInputModes() {
    return requestJson(API_ENDPOINTS.admin.backfillOrderInputModes, {
        method: "POST",
        headers: getAdminAuthHeaders()
    });
}

export function backfillTextOrderWorkbooks() {
    return requestJson(API_ENDPOINTS.admin.backfillTextOrderWorkbooks, {
        method: "POST",
        headers: getAdminAuthHeaders()
    });
}

export function backfillOfferRemarksFromAnalog() {
    return requestJson(API_ENDPOINTS.admin.backfillOfferRemarksFromAnalog, {
        method: "POST",
        headers: getAdminAuthHeaders()
    });
}

export async function wakeComputer() {
    const response = await fetch(API_ENDPOINTS.admin.wakeComputer, {
        method: "POST",
        headers: getAdminAuthHeaders()
    });

    if (!response.ok) {
        const text = await response.text().catch(() => "");
        throw new Error(text || `Ошибка сервера: ${response.status}`);
    }
}

export async function checkSiteAvailability() {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);
    const startedAt = performance.now();

    try {
        const response = await fetch("/", {
            method: "GET",
            cache: "no-store",
            signal: controller.signal
        });

        if (!response.ok) {
            throw new Error(`Сайт вернул HTTP ${response.status}`);
        }

        return {
            status: response.status,
            responseTimeMs: Math.round(performance.now() - startedAt)
        };
    } catch (error) {
        if (error.name === "AbortError") {
            throw new Error("Сайт не ответил за 10 секунд");
        }
        throw error;
    } finally {
        clearTimeout(timeoutId);
    }
}

function withQuery(url, params) {
    const query = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            query.set(key, value);
        }
    });

    return `${url}?${query.toString()}`;
}

export function fetchLlmUsageSummary({ from, to }) {
    return requestJson(withQuery(API_ENDPOINTS.admin.llmUsageSummary, { from, to }), {
        headers: getAdminAuthHeaders()
    });
}

export function fetchLlmUsageRequests({ from, to, employeeId, limit = 200 }) {
    return requestJson(withQuery(API_ENDPOINTS.admin.llmUsageRequests, { from, to, employeeId, limit }), {
        headers: getAdminAuthHeaders()
    });
}

export function fetchLlmBalance() {
    return requestJson(API_ENDPOINTS.admin.llmUsageBalance, {
        headers: getAdminAuthHeaders()
    });
}

// [[Material Download Maintenance]] #obsidian-marker
export function fetchMaterialDownloads({ search = "", status = "", offset = 0, source = "" }) {
    return requestJson(withQuery("/api/admin/material-downloads", { search, status, offset, source }), {
        headers: getAdminAuthHeaders()
    });
}
export function retryMaterialDownload(componentId, kind, source = "mouser") {
    return requestJson(`/api/admin/material-downloads/${encodeURIComponent(componentId)}/${encodeURIComponent(kind)}/retry?source=${encodeURIComponent(source)}`, {
        method: "POST", headers: getAdminAuthHeaders()
    });
}

// [[Material Routing]] #obsidian-marker
export function materialAdmin(path,body=null,query={},method) {
 return requestJson(withQuery('/api/admin/material-downloads'+path,query),{
  method:method||(body===null?'GET':'POST'),headers:{...getAdminAuthHeaders(),...(body===null?{}:{'Content-Type':'application/json'})},
  ...(body===null?{}:{body:JSON.stringify(body)})
 });
}
